import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { HubListInitialState, HubListLoad } from './hub-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { HubListService } from './hub-list.service';
import { HubBrief } from '../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type HubListStateModel = ListServerPaginationStateModel<HubBrief>;

const initialState: HubListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<HubListStateModel>({
  name: 'hubList',
  defaults: initialState,
})
@Injectable()
export class HubListState {
  constructor(private hubListService: HubListService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: HubListStateModel): HubListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: HubListStateModel): boolean {
    return state.loaded;
  }

  @Action(HubListLoad)
  getHubs(
    ctx: StateContext<HubListStateModel>,
    { payload }: HubListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.hubListService.getHubList(payload).pipe(
      take(1),
      map((list: HubBrief[]) => {
        ctx.patchState({ ...list, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(HubListInitialState)
  setInitialState(ctx: StateContext<HubListStateModel>): void {
    ctx.setState(initialState);
  }
}
